import type { UserList } from '@app/application/user-management/types'

import { userLists } from '@app/application/user-management/types'

const USER_LISTS: readonly string[] = Object.values(userLists)

export const isUserList = (value: string | undefined): value is UserList =>
  value !== undefined && USER_LISTS.includes(value)
